export { EVENT_CHANNEL } from './constants';
import { useAnalyticsEvents } from './generated/use-analytics-events';
export var useDatasourceAnalyticsEvents = function useDatasourceAnalyticsEvents() {
  return useAnalyticsEvents();
};